import { createSlice } from '@reduxjs/toolkit';

const initialStatePPacks = {
    listLoading: false,
    actionsLoading: false,
    pPacks: undefined,
    pPacksDetails: undefined,
    success: null,
    error: null,
};

export const callTypes = {
    list: "list",
    action: "action"
};

export const pPacksSlice = createSlice({
    name: "pPacks",
    initialState: initialStatePPacks,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        catchSuccess: (state, action) => {
            state.error = null;
            state.success = action.payload.success;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        startCall: (state, action) => {
            state.error = null;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        // get List PPendings
        pPacksFetched: (state, action) => {
            state.listLoading = false;
            state.pPacks = action.payload.pPacks;
            state.error = null;
        },
        // get pPendings detail
        pPacksDetailsFetched: (state, action) => {
            state.listLoading = false;
            state.pPacksDetails = action.payload.pPacksDetails;
            state.error = null;
        },
        clear: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.pPacksDetails = undefined;
            state.error = null;
            state.success = null;
        },
        clearAll: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.pPacks = undefined;
            state.pPacksDetails = undefined;
            state.error = null;
            state.success = null;
        }
    }
});